export var colors = {
    $esbuild: "#ffcf00",
    $danger: "#f44336",
    $text_primary: "#222222",
    $text_secondary: "#3a3a3a",
    $white: "#ffffff",
    $black: "#000000"
};
